import React from "react";

const KEYWORDS = [
	{
        key: "thuê xe 7 chỗ",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=2"
	},
    {
        key: "thuê xe 4 chỗ",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=1"
	},
    {
        key: "xe 4 chỗ",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "thuê xe du lịch",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "xe du lịch",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "thue xe du lịch",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "thue xe du lich",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "thue xe tu lai 7 cho",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=2"
	},
    {
        key: "thuê xe ô tô tự lái tphcm",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "thuê ô tô tự lái tphcm",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "thue xe tu lai tphcm",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "dịch vụ cho thuê xe",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "dich vu cho thue xe",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "thuê xe du lịch 7 chỗ",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=2"
	},
    {
        key: "cho thue xe du lich",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "giá thuê xe 7 chỗ",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=2"
	},
    {
        key: "xe tự lái",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "dịch vụ thuê xe tự lái",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "thuê xe 7 chỗ tự lái",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=2"
	},
    {
        key: "giá thuê xe tự lái",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "thuê xe tự lái 400k",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=3"
	},
    {
        key: "dịch vụ thuê xe",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "cho thuê xe ô tô tự lái",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "thuê xe 7 chỗ tự lái tphcm",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=2"
	},
    {
        key: "thuê xe tự lái 7 chỗ",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=2"
	},
    {
        key: "thuê xe tự lái giá rẻ",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=3"
	},
    {
        key: "giá thuê xe tự lái 7 chỗ",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=2"
	},
    {
        key: "dịch vụ thuê ô tô tự lái",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "dich vu cho thue xe tu lai tai tphcm",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "cho thue xe 7 chỗ",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=2"
	},
    {
        key: "cho thue xe tu lai tphcm",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "thue xe 7 cho",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=2"
	},
    {
        key: "giá thuê xe 7 chỗ 1 ngày",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=2"
	},
    {
        key: "thuê xe 4 chỗ tự lái",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=1"
	},
    {
        key: "cho thuê xe 4 chỗ",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=1"
	},
    {
        key: "xe du lịch 4 chỗ",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=1"
	},
    {
        key: "thuê xe có lái",
		url: "https://www.mioto.vn/withdriver/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam"
	},
    {
        key: "thuê lái xe",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "thue xe ô tô",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "cho thue xe 4 chỗ",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=1"
	},
    {
        key: "giá thuê xe 7 chỗ tự lái",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=2"
	},
    {
        key: "xe du lich",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "cho thuê xe tự lái gần đây",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "thuê xe tự lái 300k",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=3"
	},
    {
        key: "thuê xe bán tải tự lái",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=7"
	},
    {
        key: "thuê xe du lịch 4 chỗ",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=1"
	},
    {
        key: "thuê xe 7 chỗ có tài xế",
		url: "https://www.mioto.vn/withdriver/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&isCityTourMode=true&isOneWay=false&selectHour=0&vtype=2"
	},
    {
        key: "thuê xe có tài xế",
		url: "https://www.mioto.vn/withdriver/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&isCityTourMode=true&isOneWay=false&selectHour=4"
	},
    {
        key: "thuê xe 4 chỗ có tài xế",
		url: "https://www.mioto.vn/withdriver/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&isCityTourMode=true&isOneWay=false&selectHour=0&vtype=1"
	},
    {
        key: "giá thuê xe 7 chỗ có tài xế",
		url: "https://www.mioto.vn/withdriver/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&isCityTourMode=true&isOneWay=false&selectHour=0&vtype=2"
	},
    {
        key: "cần thuê xe 4 chỗ có tài xế",
		url: "https://www.mioto.vn/withdriver/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&isCityTourMode=true&isOneWay=false&selectHour=0&vtype=1"
	},
  
    {
        key: "cần thuê xe 7 chỗ có tài xế",
		url: "https://www.mioto.vn/withdriver/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&isCityTourMode=true&isOneWay=false&selectHour=0&vtype=2"
	},
    {
        key: "thuê xe có tài",
		url: "https://www.mioto.vn/withdriver/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&isCityTourMode=true&isOneWay=false&selectHour=4"
	},
    {
        key: "cho thuê xe có tài",
		url: "https://www.mioto.vn/withdriver/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&isCityTourMode=true&isOneWay=false&selectHour=0&vtype=1"
	},
    {
        key: "thuê xe ô tô có tài xế",
		url: "https://www.mioto.vn/withdriver/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&isCityTourMode=true&isOneWay=false&selectHour=4"
	},
    {
        key: "thuê xe 7 chỗ có tài",
		url: "https://www.mioto.vn/withdriver/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&isCityTourMode=true&isOneWay=false&selectHour=0&vtype=2"
	}

];

const KEYWORDS_CITY = [
	{
        key: "xe du lịch 7 chỗ",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=2"
	},
    {
        key: "thuê xe hà nội",
		url: "https://www.mioto.vn/city/hanoi"
	},
    {
        key: "thuê xe du lịch tại hà nội",
		url: "https://www.mioto.vn/city/hanoi"
	},
    {
        key: "thuê xe 7 chỗ tại hà nội",
		url: "https://www.mioto.vn/city/hochiminh"
	},
    {
        key: "thuê xe tự lái đà nẵng",
		url: "https://www.mioto.vn/find/filter?address=%C4%90%C3%A0%20N%E1%BA%B5ng&loc=MTYuMDYyNzQ3LTEwOC4yMTU4MTY="
	},
    {
        key: "thuê xe tự lái bình dương",
		url: "https://www.mioto.vn/find/filter?address=B%C3%ACnh%20D%C6%B0%C6%A1ng&loc=MTAuOTkzMDA5LTEwNi42NTU2NTY="
	},
    {
        key: "thuê xe tự lái biên hòa",
		url: "https://www.mioto.vn/find/filter?address=Tỉnh%20Đồng%20Nai"
	},
    {
        key: "thuê xe tự lái đà lạt",
		url: "https://www.mioto.vn/find/filter?address=%C4%90%C3%A0%20L%E1%BA%A1t&loc=MTEuOTQwMzU3LTEwOC40NTg5NQ=="
	},
    {
        key: "thuê xe tự lái phú quốc",
		url: "https://www.mioto.vn/find/filter?address=Ph%C3%BA%20Qu%E1%BB%91c&loc=MTAuMjIzLTEwMy45NzM="
	},
    {
        key: "thuê xe tự lái quy nhơn",
		url: "https://www.mioto.vn/find/filter?address=Quy%20Nh%C6%A1n&loc=MTMuNzgyOTY3My0xMDkuMjE5NjYzMzk5OTk5OTQ="
	},
    {
        key: "thuê xe tự lái nha trang",
		url: "https://www.mioto.vn/find/filter?address=Nha%20Trang&loc=MTIuMjQ1MDctMTA5LjE5NDMy"
	},
    {
        key: "thuê xe tự lái hải phòng",
		url: "https://www.mioto.vn/find/filter?address=H%E1%BA%A3i%20Ph%C3%B2ng&loc=MjAuODQ0OTExNDk5OTk5OTktMTA2LjY4ODA4NDE="
	},
    {
        key: "thuê xe tự lái vũng tàu",
		url: "https://www.mioto.vn/find/filter?address=V%C5%A9ng%20T%C3%A0u&loc=MTAuNDExMzc5Ny0xMDcuMTM2MjIzOTk5OTk5OTc="
	},
    {
        key: "thuê xe du lịch 7 chỗ",
		url: "https://www.mioto.vn/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&vtype=2"
	},
    {
        key: "thuê xe tự lái cần thơ",
		url: "https://www.mioto.vn/find/filter?address=C%E1%BA%A7n%20Th%C6%A1&loc=MTAuMDQ1MTYyLTEwNS43NDY4NTc="
	},
    {
        key: "thuê xe ô tô tự lái đà nẵng",
		url: "https://www.mioto.vn/find/filter?address=%C4%90%C3%A0%20N%E1%BA%B5ng&loc=MTYuMDYyNzQ3LTEwOC4yMTU4MTY="
	},
    {
        key: "thuê xe ô tô tự lái bình dương",
		url: "https://www.mioto.vn/find/filter?address=B%C3%ACnh%20D%C6%B0%C6%A1ng&loc=MTAuOTkzMDA5LTEwNi42NTU2NTY="
	},
    {
        key: "thuê xe ô tô tự lái biên hòa",
		url: "https://www.mioto.vn/find/filter?address=T%E1%BB%89nh%20%C4%90%E1%BB%93ng%20Nai"
	},
    {
        key: "thuê xe ô tô tự lái đà lạt",
		url: "https://www.mioto.vn/find/filter?address=%C4%90%C3%A0%20L%E1%BA%A1t&loc=MTEuOTQwMzU3LTEwOC40NTg5NQ=="
	},
    {
        key: "thuê xe ô tô tự lái phú quốc",
		url: "https://www.mioto.vn/find/filter?address=Ph%C3%BA%20Qu%E1%BB%91c&loc=MTAuMjIzLTEwMy45NzM="
	},
    {
        key: "thuê xe ô tô tự lái quy nhơn",
		url: "https://www.mioto.vn/find/filter?address=Quy%20Nh%C6%A1n&loc=MTMuNzgyOTY3My0xMDkuMjE5NjYzMzk5OTk5OTQ="
	},
    {
        key: "thuê xe ô tô tự lái nha trang",
		url: "https://www.mioto.vn/find/filter?address=Nha%20Trang&loc=MTIuMjQ1MDctMTA5LjE5NDMy"
	},
    {
        key: "thuê xe ô tô tự lái hải phòng",
		url: "https://www.mioto.vn/find/filter?address=H%E1%BA%A3i%20Ph%C3%B2ng&loc=MjAuODQ0OTExNDk5OTk5OTktMTA2LjY4ODA4NDE="
	},
    {
        key: "thuê xe ô tô tự lái vũng tàu",
		url: "https://www.mioto.vn/find/filter?address=V%C5%A9ng%20T%C3%A0u&loc=MTAuNDExMzc5Ny0xMDcuMTM2MjIzOTk5OTk5OTc="
	},
    {
        key: "thuê xe ô tô tự lái cần thơ",
		url: "https://www.mioto.vn/find/filter?address=C%E1%BA%A7n%20Th%C6%A1&loc=MTAuMDQ1MTYyLTEwNS43NDY4NTc="
	},
    {
        key: "thuê xe có tài xế hà nội",
		url: "https://www.mioto.vn/withdriver/find/filter?address=H%C3%A0%20N%E1%BB%99i"
	},
    {
        key: "thuê xe có tài xế tphcm",
		url: "https://www.mioto.vn/withdriver/find/filter?address=Th%C3%A0nh%20ph%E1%BB%91%20H%E1%BB%93%20Ch%C3%AD%20Minh,%20Vi%E1%BB%87t%20Nam&isCityTourMode=true&isOneWay=false&selectHour=4"
	},
    {
        key: "thuê xe có tài xế đà nẵng",
		url: "https://www.mioto.vn/withdriver/find/filter?address=%C4%90%C3%A0%20N%E1%BA%B5ng&loc=MTYuMDYyNzQ3LTEwOC4yMTU4MTY="
	}

];


export const HiddenLink = () => {

    return (
        <React.Fragment>
            {KEYWORDS.map((key, i) => <a key={i} href={key.url} hidden>{key.key}</a>)}
        </React.Fragment>
    )
}

export const HiddenCityLink = () => {

    return (
        <React.Fragment>
            {KEYWORDS_CITY.map((key, i) => <a key={i} href={key.url} hidden>{key.key}</a>)}
        </React.Fragment>
    )
}